
export const northpowerBounds = {
    north: -35.3,
    south: -36.4,
    west: 173.3,
    east: 174.62,
}
